<template>
  <v-form ref="form" v-model="valid">
    <v-text-field
      v-model="username"
      :counter="20"
      :rules="usernameRules"
      label="Name"
      required
    ></v-text-field>

    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      required
    ></v-text-field>

    <v-text-field
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[passwordRules.required, passwordRules.password]"
      :type="showPassword ? 'text' : 'password'"
      name="input-10-2"
      label="Password"
      hint="Min. 8 characters,one capital letter, a number and a special character."
      v-model="password"
      class="input-group--focused"
      @click:append="showPassword = !showPassword"
    ></v-text-field>
    <v-container>
      <v-row class="justify-end">
        <v-btn
          color="primary"
          @click="createUser"
          :disabled="!createUserEnabled"
          >Submit</v-btn
        >
        <v-btn class="ml-2" @click="closeAndReset">Close</v-btn>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  props: {
    onCloseClick: Function,
  },
  data: () => ({
    valid: false,
    username: '',
    usernameRules: [
      (v) => !!v || 'Name is required',
      (v) => (v && v.length <= 20) || 'Name must be less than 20 characters',
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    showPassword: false,
    password: '',
    passwordRules: {
      required: (value) => !!value || 'Required.',
      min: (v) => (v && v.length >= 8) || 'Min 8 characters',
      emailMatch: () => ('The email and password you entered don\'t match'),
      password: (value) => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/; // eslint-disable-line no-useless-escape
        return (
          pattern.test(value)
          || 'Min. 8 characters with at least one capital letter, a number and a special character.'
        );
      },
    },
    isLoading: false,
    failedToCreateUserMessage: '',
    isFailMessageActive: false,
  }),
  computed: {
    createUserEnabled() {
      return !this.isLoading && this.valid
        && ((this.username || '').length > 1)
        && ((this.password || '').length > 1);
    },
  },
  methods: {
    closeAndReset() {
      this.onCloseClick();
      this.reset();
    },
    reset() {
      this.valid = false;
      this.$refs.form.reset();
    },
    onSuccess(message, data) {
      this.reset();
      this.$toast.success(message);
    },
    onError(message, data) {
      this.$toast.error(message);
    },
    createUser() {
      this.isLoading = true;
      this.isFailMessageActive = false;
      this.failedToCreateUserMessage = '';
      this.$toast('Creating user...');
      const userCreateDetails = {
        userName: this.username,
        userEmail: this.email,
        userPassword: this.password,
      };
      this.$store.dispatch('usersAdminStore/createUser', userCreateDetails)
        .then((resp) => { this.onSuccess('User Created', resp); })
        .catch((err) => {
          this.onError('Failed to create user');
          this.failedToCreateUserMessage = `${err.error} : ${err.details}`;
          this.isFailMessageActive = true;
        })
        .finally(() => { this.isLoading = false; });
    },
  },
};
</script>
